// extracted by mini-css-extract-plugin
export var cancelButton = "_qo-5";
export var content = "_qo-3";
export var createButton = "_qo-6";
export var drawerContainer = "_qo-0";
export var footer = "_qo-2";
export var header = "_qo-1";
export var orderFormColumn = "_qo-4";